import React from 'react';

import Link from '../../../shared/components/hyperlink';
import TechSpecs from '../../../product/components/tech-specs';
import PDPSpecsRow from './pdp-specs-row';
import PDPReturns from '../pdp-returns';

import '../../css/pdp-specs.less';

class PDPSpecs extends React.Component {

    constructor(props) {
        super(props);
    }

    renderSpecs(techSpecs, compatiblePrinters){
        const { specs=[], disclaimers=[] } = techSpecs || {};
        //TEMP: We will eventually have this information already in specs table
        let specsArray = specs.slice();
        if(compatiblePrinters){
            //put compatible printers after 'Compatible ink types' otherwise put at end
            let printerIndex = specs.findIndex(s => s.type ==='Compatible ink types') + 1;
            if(printerIndex < 1){
                printerIndex = specs.length;
            }
            specsArray.splice(printerIndex, 0,{
                type: 'Compatible Printers',
                ordinal: printerIndex,
                value: compatiblePrinters.value.map((v, i, arr) => {
                    return (<React.Fragment key={v.linkUrl}>
                                <Link to={v.linkUrl} linkType='absolute'>{v.label}</Link>{` (${v.sku})${i < arr.length - 1 ? ' ; ': '' }`}
                            </React.Fragment>);
                })
            });
        }

        return(
            <div>
                {
                    specsArray.map((spec,i) =>
                        <PDPSpecsRow key={`${spec.type}-${i}`} name={spec.type} value={spec.value} disclaimers={disclaimers} />
                    )
                }
                <div className="pdp-line"></div>
                <ul className='disclaimer-list'>
                    {
                        disclaimers.map((disclaimer,i)=>
                            <li key={`footnote-${i}`}>{disclaimer}</li>
                        )
                    }
                </ul>
            </div>
        )
    }

    render() {
        const { product, disclaimers } = this.props;
        const { attributes={}, compatiblePrinters, prdClass } = product;
        const { product_doc: prodDoc, return_policy } = attributes;

        return (
            <div className='pdp-specs'>
                <div tabIndex={0} aria-label="Product specifications" className='pdp-tab-header'>Product specifications</div>
                <div className='specs-table'>
                    {prodDoc && <PDPSpecsRow name='HP Data Sheet' prodDoc={prodDoc}/>}
                    <TechSpecs sku={product.sku}>
                        {({ techSpecs }) => {
                             return this.renderSpecs(techSpecs, compatiblePrinters);
                         }
                        }
                    </TechSpecs>
                </div>
                <PDPReturns prdClass={prdClass} returnsMessage={return_policy} />
            </div>
        )
    }
};

PDPSpecs.defaultProps = {
    specs: [],
}


export default PDPSpecs;